import { render, staticRenderFns } from "./videoPlayPage.vue?vue&type=template&id=04cfc33d&scoped=true"
import script from "./videoPlayPage.vue?vue&type=script&lang=js"
export * from "./videoPlayPage.vue?vue&type=script&lang=js"
import style0 from "./videoPlayPage.vue?vue&type=style&index=0&id=04cfc33d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cfc33d",
  null
  
)

export default component.exports